import React from 'react';

/**
 * Brand wordmark for "SchoolZest":
 *   • "S" and "Z" in brand dark blue (#1a3a61)
 *   • "chool" and "est" in brand light blue (#7aa0c4)
 *
 * Props:
 *   theme             - 'light' (default) for light backgrounds, 'dark' for dark backgrounds
 *   suffix            - extra text appended after "SchoolZest" (e.g. "AI", "Management System")
 *   suffixTight       - when true, no gap between "SchoolZest" and suffix (e.g. "AI")
 *   suffixClassName   - extra classes for the suffix span
 *   suffixStyle       - inline style for the suffix span (overrides defaults)
 */
export const Brand = ({
  className = '',
  theme = 'light',
  suffix = '',
  suffixTight = false,
  suffixClassName = '',
  suffixStyle,
}) => {
  const isDark = theme === 'dark';
  const accent = isDark ? '#ffffff' : '#1a3a61';
  const body = isDark ? '#a1b4c8' : '#7aa0c4';
  return (
    <span className={`inline-flex items-baseline ${className}`} data-testid="brand-wordmark">
      <span style={{ color: accent }}>S</span>
      <span style={{ color: body }}>choolZest</span>
      {suffix && (
        <span
          className={`${suffixTight ? '' : 'ml-1'} ${suffixClassName}`}
          style={suffixStyle || { color: accent }}
        >
          {suffix}
        </span>
      )}
    </span>
  );
};

export default Brand;
